import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { NgClass, NgStyle, TitleCasePipe } from '@angular/common';
import { Component, inject } from '@angular/core';

import { DsButton } from '@frontend/ui/button';
import { DsDivider } from '@frontend/ui/divider';
import { DsModal, DsModalContent, DsModalHeader, DsModalHeaderDrag } from '@frontend/ui/modal';
import { DynamicHtmlDirective } from '@frontend/vanilla/core';

@Component({
    selector: 'view-card-popup',
    standalone: true,
    imports: [DsModal, DsModalContent, DsModalHeader, DsButton, DsModalHeaderDrag, DsDivider, NgStyle, NgClass, TitleCasePipe, DynamicHtmlDirective],
    templateUrl: './view-card-popup.component.html',
    styleUrls: ['./view-card-popup.component.scss'],
})
export class ViewCardPopupComponent {
    dialogRef = inject(DialogRef);
    data = inject(DIALOG_DATA);
    tierInfoColor: string;

    ngOnInit() {
        this.setTierInfoColor();
    }

    private setTierInfoColor(): void {
        if (this.data?.tierInfo) {
            const tier = this.data.tierInfo.toLowerCase();
            this.tierInfoColor = tier === 'pearl' || tier === 'gold' ? 'black' : 'white';
        }
    }

    close(): void {
        this.dialogRef.close();
    }
}
